import AutocompleteField from "../../../components/fields/autocompleteField/AutocompleteField.vue";
import { CompraService } from "../../../services/CompraService";
import { EmpenhoService } from "../../../services/EmpenhoService";

export default {
    components: {
        AutocompleteField
    },
    data() {
        return {
            dialogHistorico: false,
            compra: {
                itens: []
            },
            itemSelected: [],
            planoSelected: [],
            allPanelsOpen: {},
            planos: [],
            dotacoes: [],
            dotacaoHeaders: [
                { text: 'Dotação', value: 'dotacao' },
                { text: 'Valor Total Empenhado', value: 'valor_total_empenhado' },
                { text: 'Valor Total Liquidado', value: 'total_liquidado' },
            ],
            planoHeaders: [
                { text: 'Nome', value: 'nome' },
                { text: 'Descrição', value: 'descricao' },
                { text: 'Doc. SEI', value: 'documento_sei' },
                { text: 'Status', value: 'status' },
            ],
            planosSelecionados: [],
            planoSelecionado: null,
            todosPlanos: [],
        };
    },
    computed: {
        hasItems() {
            return this.compra.itens.length > 0;
        },
        valorTotalEmpenhado() {
            return this.compra.itens.reduce((total, item) => {
                return total + item.empenhos.reduce((subtotal, empenho) => subtotal + parseFloat(empenho.empenho_valor_total || 0), 0);
            }, 0).toFixed(2);
        },
        somaLiquidacao() {
            return this.compra.itens.reduce((total, item) => {
                return total + item.empenhos.reduce((subtotal, empenho) => subtotal + parseFloat(empenho.conformidade_orcamentaria_valor_total || 0), 0);
            }, 0).toFixed(2);
        }
    },
    methods: {
        maskCnpjCpf(value) {
            if (value.length <= 11) {
                return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
            } else {
                return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
            }
        },
        formatCodigoPrograma(codigo) {
            return String(codigo).padStart(3, '0');
        },
        formatCodigoSubAcao(codigo) {
            return String(codigo).padStart(4, '0');
        },
        formatCodigoFuncao(codigo) {
            return String(codigo).padStart(2, '0');
        },
        formatCodigoElementoItem(codigo) {
            if (codigo != 0 && codigo < 10) {
                return String(codigo).padStart(2, '0');
            }
            return codigo;
        },
        groupEmpenhos(empenhos) {
            const grouped = {};
            empenhos.forEach(empenho => {
                if (!grouped[empenho.numero_empenho]) {
                    const elementoDespesa = empenho.elemento_despesa_codigo 
                        ? `${empenho.elemento_despesa_codigo}${empenho.elemento_descricao ? ' - ' + empenho.elemento_descricao : ''}`
                        : '';
                    
                    const fonteRecurso = empenho.fonte_recurso_codigo 
                        ? `${empenho.fonte_recurso_codigo}${empenho.fonte_descricao ? ' - ' + empenho.fonte_descricao : ''}`
                        : '';
                    
                    const funcao = empenho.funcao_codigo 
                        ? `${empenho.funcao_codigo}${empenho.funcao_descricao ? ' - ' + empenho.funcao_descricao : ''}`
                        : '';
                    
                    const grupoDespesa = empenho.grupo_codigo 
                        ? `${empenho.grupo_codigo}${empenho.grupo_descricao ? ' - ' + empenho.grupo_descricao : ''}`
                        : '';
                    
                    const itemDespesa = empenho.elemento_item_codigo 
                        ? `${empenho.elemento_item_codigo}${empenho.elemento_item_descricao ? ' - ' + empenho.elemento_item_descricao : ''}`
                        : '';

                    grouped[empenho.numero_empenho] = {
                        numero_empenho: empenho.numero_empenho,
                        formatted_empenho: empenho.formatted_empenho,
                        totalEmpenhado: 0,
                        totalLiquidado: 0,
                        elemento_despesa: elementoDespesa,
                        fonte_recurso: fonteRecurso,
                        funcao: funcao,
                        grupo_despesa: grupoDespesa,
                        item_despesa: itemDespesa
                    };
                }
                grouped[empenho.numero_empenho].totalEmpenhado += parseFloat(empenho.empenho_valor_total || 0);
                grouped[empenho.numero_empenho].totalLiquidado += parseFloat(empenho.conformidade_orcamentaria_valor_total || 0);
            });
            return Object.values(grouped);
        },
        async historico () {
            try {
                const response = await EmpenhoService.history(this.$route.params.id);
                if (response && response.data) {
                    this.itemSelected = response.data;
                    this.dialogHistorico = true;
                }
            } catch (error) {
                console.error('Erro ao carregar o histórico: ', error);
            }
        },
        async carregarCompra(id) {
            try {
                const response = await CompraService.show(id);
                if (response && response.data) {
                    this.compra = response.data;
                    this.dotacoes = [];
                    const uniqueDotacoes = new Set();

                    this.allPanelsOpen = this.compra.itens.reduce((acc, item) => {
                        acc[item.numero_item_processo] = Array.from({ length: item.empenhos.length }, (_, i) => i);
                        return acc;
                    }, {});

                    this.compra.itens.forEach(item => {
                        item.empenhos.forEach(empenho => {
                            if (empenho.dotacao && !uniqueDotacoes.has(empenho.dotacao.id)) {
                                uniqueDotacoes.add(empenho.dotacao.id);
                                this.dotacoes.push(empenho.dotacao);
                            }
                        });
                    });
                }
            } catch (error) {
                console.error('Erro ao carregar os dados: ', error);
            }
        },
        async atribuirPlano() {
            if (!this.planoSelecionado) {
                console.error("Nenhum plano de aquisição selecionado.");
                return;
            }
            try {
                const formData = new FormData();
                formData.append("plano_aquisicao", this.planoSelecionado);

                const response = await CompraService.atribuirPlanos(this.$route.params.id, formData);
                if (response) {
                    this.carregarPlanos();
                    this.carregarTodosPlanos(this.$route.params.id);
                    this.planoSelecionado = null;
                }
            } catch (error) {
                console.error("Erro ao atribuir plano de aquisição:", error);
            }
        },
        async carregarTodosPlanos(id) {
            try {
                const response = await CompraService.buscarPlanosDisponiveis(id);
                if (response && response.data) {

                    this.todosPlanos = response.data.map((plano) => {
                        return {
                            text: plano.nome + " - " + plano.descricao,
                            value: plano.id,
                        };
                    });
                }
            } catch (error) {
                console.error("Erro ao carregar todos os planos de aquisição:", error);
            }
        },
        async carregarPlanos() {
            try {
                const response = await CompraService.buscarPlanos(this.$route.params.id);
                if (response && response.data) {
                    this.planos = response.data;
                }
            } catch (error) {
                console.error('Erro ao buscar planos:', error);
            }
        }
    },
    created() {
        this.carregarCompra(this.$route.params.id);
        this.carregarPlanos(this.$route.params.id);
        this.carregarTodosPlanos(this.$route.params.id);
    }
};